import { DashboardService } from './../../home/services/dashboard.service';
import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BASE_URL } from '../../config/config';
import { StockService } from './../../home/services/stocks.service';
import { CommonAlertService } from './../../services/common-alert.service';


@Component({
  selector: 'app-dashboard-tracking-modal',
  templateUrl: './dashboard-tracking-modal.component.html',
  styleUrls: ['./dashboard-tracking-modal.component.scss']
})
export class DashboardTrackingModalComponent implements OnInit {

  public displacementData: any;
  public displacementHeader: any;
  public ImgName: any;
  public updateData: any;
  public rejectData: any;
  public successMsg: any;
  public rfidUpdatePermission: any;
  public updateRFID: any;
//  rfidUpdatePermission = true; 

  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<DashboardTrackingModalComponent>,public stockService: StockService,  public commonAlertService: CommonAlertService,
 public dashboardService: DashboardService,  @Inject(MAT_DIALOG_DATA) data, private ren: Renderer2) {

    this.displacementHeader = data.data;
    this.displacementData = data.data.displacements;
    if (this.displacementHeader.image_name) {
           this.ImgName = BASE_URL.APP_URL +  this.displacementHeader.image_name;
         } else {
           this.ImgName = BASE_URL.APP_URL +  'noImage.png';
         }
    if (this.displacementHeader.is_closed == 0) {
        this.rfidUpdatePermission = true;
     } 
    this.updateData = {
      token: localStorage.getItem('token'),
      invoice_product_stock_id: this.displacementHeader.trackingId,
      imp_status_id: 1,
    };

   this.rejectData = {
      token: localStorage.getItem('token'),
      invoice_product_stock_id: this.displacementHeader.trackingId,
      imp_status_id: 2,
    };

  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  acceptDialog(updateData){
  this.successMsg = 'Implant Accepted  Successfully';
   this.stockService.updateRFID(updateData).subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        } 
   });
   this.dialogRef.close();
  }

 rejectDialog(rejectData){
  this.successMsg = 'Implant Rejected  Successfully';
   this.stockService.updateRFID(rejectData).subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
   });
   this.dialogRef.close();
  }


}
